import React from 'react';

export default function PartnerLogos() {
  return (
    <section
      className="w-full mx-auto flex flex-col justify-center items-center bg-white"
      style={{ scrollMarginTop: '150px' }}
    >
      <div className="max-w-[1440px] w-full px-4 sm:px-12 py-12 space-y-12 sm:space-y-28">
        {/* Top Row: 3 logos */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center sm:justify-between items-center gap-6 sm:gap-10">
          <img
            src="/PartnerLogos/accenture.svg"
            alt="Accenture"
            className="h-16 sm:h-20 object-contain"
          />
          <img
            src="/PartnerLogos/pwc.svg"
            alt="PwC"
            className="h-20 sm:h-28 object-contain"
          />
          <img
            src="/PartnerLogos/deloitte.svg"
            alt="Deloitte"
            className="h-16 sm:h-20 object-contain"
          />
        </div>

        {/* Middle Row: 2 logos */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-6 sm:gap-x-80 sm:ml-20">
          <img
            src="/PartnerLogos/ey.svg"
            alt="EY"
            className="h-20 sm:h-28 object-contain"
          />
          <img
            src="/PartnerLogos/ncs.svg"
            alt="NCS"
            className="h-16 sm:h-20 object-contain"
          />
        </div>

        {/* Bottom Row: 2 logos */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center sm:justify-between items-center gap-6 sm:gap-10">
          <img
            src="/PartnerLogos/capgemini.svg"
            alt="Capgemini"
            className="h-20 sm:h-28 object-contain"
          />
          <img
            src="/PartnerLogos/st-engineering.svg"
            alt="ST Engineering"
            className="h-16 sm:h-20 object-contain"
          />
        </div>
      </div>
    </section>
  );
}
